import { ApiService }     from '../../app-lite/api/api.service';
import { SessionService } from '../../app-lite/sessions/session.service';

import Mitchell1SettingsHtml from './mitchell1.settings.html';

export function Mitchell1States (
   $stateProvider : ng.ui.IStateProvider
) {
  $stateProvider
  .state({
    controller : 'Mitchell1SettingsCtrl',
    name       : 'app.mitchell1-settings',
    templateUrl: Mitchell1SettingsHtml,
    url        : '/mitchell1-settings',
    resolve    : {
      integrations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      session     : ( sessionObjAPI : SessionService ) : ng.IPromise<any> => sessionObjAPI.refresh()
    },
  });
}
